import {React ,useState,useEffect} from "react";

const VariableInput = ({ variable, availableAttributes, value, onChange, selectedContacts,}) => {
  const [mode, setMode] = useState(value?.mode || (variable.variableType === 'numbered' ? 'static' : 'dynamic'));
  const [staticValue, setStaticValue] = useState(value?.staticValue || "");
  const [attributeName, setAttributeName] = useState(
    value?.attributeName || variable.attributeName || availableAttributes[0]
  );

  // Sync upward whenever values change
  const updateParent = (updates) => {
    const newValue = {
      mode,
      staticValue,
      attributeName,
      ...updates,
    };
    onChange(newValue);
  };

  const handleModeChange = (newMode) => {
    setMode(newMode);
    updateParent({ mode: newMode });
  };

  const handleStaticValueChange = (newValue) => {
    setStaticValue(newValue);
    updateParent({ staticValue: newValue });
  };

  const handleAttributeChange = (newAttribute) => {
    setAttributeName(newAttribute);
    updateParent({ attributeName: newAttribute });
  };
useEffect(() => {
  if (variable.variableType === "named") {
    updateParent({
      mode: "dynamic",
      attributeName,
    });
  }
}, [variable.variableType, attributeName]);
  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 mb-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-medium text-[#333]">
          {variable.label}
          <span className="text-sm text-gray-500 ml-2">
            ({variable.type === 'header' ? 'Header' : 'Body'})
          </span>
        </h4>
        <div className="text-xs bg-gray-100 px-2 py-1 rounded">
          {variable.originalMatch}
        </div>
      </div>

      {/* Mode Switch - Only for numbered variables */}
      {variable.variableType === 'numbered' && (
        <div className="mb-4">
          <label className="text-sm font-medium text-[#333] mb-2 block">Mode</label>
          <div className="flex gap-4">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name={`mode_${variable.key}`}
                value="static"
                checked={mode === "static"}
                onChange={() => handleModeChange("static")}
                className="mr-2"
              />
              <span className="text-sm">Static Value</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name={`mode_${variable.key}`}
                value="dynamic"
                checked={mode === "dynamic"}
                onChange={() => handleModeChange("dynamic")}
                className="mr-2"
              />
              <span className="text-sm">From Contact Data</span>
            </label>
          </div>
        </div>
      )}

      {/* Named variables info */}
      {variable.variableType === 'named' && (
        <div className="mb-4 p-3 bg-blue-50 rounded-lg">
          <div className="text-sm text-blue-700">
            <strong>Auto-mapped:</strong> This variable will automatically use data from your contacts' "{attributeName}" attribute.
          </div>
        </div>
      )}

      {/* Static Input */}
      {mode === "static" && (
        <div>
          <label className="text-sm font-medium text-[#333] mb-1 block">
            Static Value
          </label>
          <input
            type="text"
            value={staticValue}
            onChange={(e) => handleStaticValueChange(e.target.value)}
            placeholder={`Enter value for ${variable.originalMatch}`}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 placeholder-gray-400 text-sm"
          />
          <div className="text-xs text-gray-500 mt-1">
            This value will be used for all {selectedContacts.length} contacts
          </div>
        </div>
      )}

      {/* Dynamic Attribute Selection */}
      {mode === "dynamic" && (
        <div>
          <label className="text-sm font-medium text-[#333] mb-1 block">
            Contact Attribute
          </label>
          <select
            value={attributeName}
            onChange={(e) => handleAttributeChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
          >
            {availableAttributes.map((attr) => (
              <option key={attr} value={attr}>
                {attr.charAt(0).toUpperCase() + attr.slice(1)}
              </option>
            ))}
          </select>
          <div className="text-xs text-gray-500 mt-1">
            Values will be taken from each contact's "{attributeName}" field
          </div>
        </div>
      )}
    </div>
  );
};

export default VariableInput;
